// Mirrors the server-side order payment gate (olc-server order-payment-gate.service.js).
const PAYMENT_METHOD_REQUIRED_CODE = 'PAYMENT_METHOD_REQUIRED';

/**
 * Live-mode orders need a default card on file; test-mode orders are never charged.
 * Fails open while the organization is not loaded so the server stays the source of truth.
 */
export const isPaymentMethodMissing = (user) =>
  user?.isLiveMode === true &&
  !!user.organization &&
  !user.organization.defaultPaymentMethodStripeId;

/** True when an API response (axios `response`) is the server's "add a card first" rejection. */
export const isPaymentMethodRequiredResponse = (response) =>
  response?.status === 422 && response?.data?.data?.code === PAYMENT_METHOD_REQUIRED_CODE;
